"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidPropertyError = exports.PropertyLengthError = exports.UnrecognizedTypeError = exports.LinkNotFoundError = exports.ReservedPropertyError = void 0;

var _constants = require("./constants");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ReservedPropertyError = /*#__PURE__*/function (_Error) {
  _inherits(ReservedPropertyError, _Error);

  var _super = _createSuper(ReservedPropertyError);

  function ReservedPropertyError() {
    _classCallCheck(this, ReservedPropertyError);

    return _super.call(this, "one of your property names is reserved. These property names are not allowed: ".concat(_constants.RESERVED_PROPERTIES));
  }

  return ReservedPropertyError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ReservedPropertyError = ReservedPropertyError;

var LinkNotFoundError = /*#__PURE__*/function (_Error2) {
  _inherits(LinkNotFoundError, _Error2);

  var _super2 = _createSuper(LinkNotFoundError);

  function LinkNotFoundError(selector) {
    _classCallCheck(this, LinkNotFoundError);

    return _super2.call(this, "You must pass a valid selector in order to track a link, but ".concat(selector, " was not found. (Make sure the DOM is loaded before calling this tracking function)."));
  }

  return LinkNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.LinkNotFoundError = LinkNotFoundError;

var UnrecognizedTypeError = /*#__PURE__*/function (_Error3) {
  _inherits(UnrecognizedTypeError, _Error3);

  var _super3 = _createSuper(UnrecognizedTypeError);

  function UnrecognizedTypeError(type, allowedTypes) {
    _classCallCheck(this, UnrecognizedTypeError);

    return _super3.call(this, "Invalid argument. ".concat(type, " must be one of ").concat(allowedTypes, "."));
  }

  return UnrecognizedTypeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.UnrecognizedTypeError = UnrecognizedTypeError;

var PropertyLengthError = /*#__PURE__*/function (_Error4) {
  _inherits(PropertyLengthError, _Error4);

  var _super4 = _createSuper(PropertyLengthError);

  function PropertyLengthError(property) {
    _classCallCheck(this, PropertyLengthError);

    return _super4.call(this, "The value of ".concat(property, " is too long (String are 255 max, lists 10,000 elements max)"));
  }

  return PropertyLengthError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.PropertyLengthError = PropertyLengthError;

var InvalidPropertyError = /*#__PURE__*/function (_Error5) {
  _inherits(InvalidPropertyError, _Error5);

  var _super5 = _createSuper(InvalidPropertyError);

  function InvalidPropertyError(value, property, event) {
    _classCallCheck(this, InvalidPropertyError);

    return _super5.call(this, "".concat(event, " events require a valid ").concat(property, " property, you provided ").concat(value));
  }

  return InvalidPropertyError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.InvalidPropertyError = InvalidPropertyError;